import React from "react";
import { Navigate } from "react-router-dom";
import { AESTHETICS_ENABLED } from "../config/aesthetics";

interface AestheticsGuardProps {
  children: React.ReactNode;
}

const AestheticsGuard: React.FC<AestheticsGuardProps> = ({ children }) => {
  if (!AESTHETICS_ENABLED) {
    // Redirect to main dashboard if aesthetics is disabled
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AestheticsGuard;